/* EcomChief v2 — product: gallery, packages, rename, add to deal. Needs ec-v2.js. */
(function () {
  'use strict';
  var E = window.ECX;
  if (!E) return;
  var $ = E.$, $$ = E.$$, esc = E.esc, money = E.money, toast = E.toast, Overlay = E.Overlay, reduce = E.reduce, root = E.root;
  /* ======================================================================
     PRODUCT
     ====================================================================== */
  class EcxProduct extends HTMLElement {
    connectedCallback() {
      this.form = $('form[data-ecx-form]', this);
      this.idInput = this.form ? $('input[name="id"]', this.form) : null;
      this.gallery();
      this.options();
      this.rename();
      this.addToCart();
      this.mobileBar();
      this.stick();
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.ro) this.ro.disconnect(); }
    stick() {
      /* columns taller than the screen scroll until their bottom shows, then hold */
      var cols = $$('.ecx-pdp > *', this);
      if (!cols.length || !('ResizeObserver' in window)) return;
      var gap = 20, hdr = parseFloat(getComputedStyle(this).getPropertyValue('--hdr')) || 72;
      var set = function () {
        var vh = window.innerHeight, t = hdr + gap;
        cols.forEach(function (c) { var h = c.offsetHeight; c.style.setProperty('--stick', Math.round(h + t + gap > vh ? Math.min(t, vh - h - gap) : t) + 'px'); });
      };
      this.ro = new ResizeObserver(set);
      cols.forEach(function (c) { this.ro.observe(c); }, this);
      window.addEventListener('resize', set, { passive: true });
      set();
    }
    gallery() {
      var track = $('[data-track]', this), thumbs = $$('[data-thumb]', this), cnt = $('[data-stage-count]', this);
      if (!track || !thumbs.length) return;
      var sync = function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        if (cnt) cnt.textContent = (i + 1) + ' / ' + thumbs.length;
      };
      var to;
      track.addEventListener('scroll', function () { clearTimeout(to); to = setTimeout(sync, 60); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * (+t.dataset.thumb), behavior: reduce ? 'auto' : 'smooth' }); }); });
    }
    options() {
      /* One state for the buy box: selected option values -> the real Shopify
         variant -> price, availability, cart id and (for store designs) the order
         details. Prices only ever come from the variant data Liquid prints. */
      var self = this, vj = $('[data-ecx-variants]', this);
      this.variants = vj ? JSON.parse(vj.textContent) : [];
      if (!this.variants.length) return;
      var start = this.variants.filter(function (v) { return String(v.id) === String(self.idInput && self.idInput.value); })[0] || this.variants[0];
      this.state = { options: start.o.slice(), variant: start };
      this.inputs = $$('[data-opt-input]', this);
      this.inputs.forEach(function (i) {
        if (i.checked) self.state.options[+i.dataset.optInput] = i.value;
        i.addEventListener('change', function () { if (i.checked) { self.state.options[+i.dataset.optInput] = i.value; self.sync(true); } });
      });
      var emailBox = $('[data-email-addon]', this);
      if (emailBox) emailBox.addEventListener('change', function () { self.sync(false); });
      var thumbs = $$('[data-thumb]', this), stage = $('[data-look-stage]', this);
      if (stage) thumbs.forEach(function (t) { t.addEventListener('click', function () { stage.hidden = true; }); });
      this.sync(false);
    }
    find(opts) {
      return this.variants.filter(function (v) { return v.o.every(function (x, j) { return x === opts[j]; }); })[0] || null;
    }
    with(i, value) { var o = this.state.options.slice(); o[i] = value; return this.find(o); }
    sync(user) {
      var self = this, st = this.state, v = this.find(st.options);
      st.variant = v;
      var tot = $('[data-total]', this), mtot = $('[data-mtotal]', this), nudge = $('[data-nudge]', this), btns = $$('[data-add]', this);
      if (this.idInput) {
        this.idInput.value = v ? v.id : '';
        /* Shopify's express checkout button reads the form, so tell it the id changed */
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var emailBox = $('[data-email-addon]', this);
      var selectedPrice = v ? v.p + (emailBox && emailBox.checked ? (+emailBox.dataset.emailPrice || 0) : 0) : 0;
      if (tot && v) tot.textContent = money(selectedPrice);
      if (mtot && v) mtot.textContent = money(selectedPrice);
      var ok = !!(v && v.a);
      btns.forEach(function (b) { b.disabled = !ok; b.textContent = ok ? b.dataset.addLabel : b.dataset.soldLabel; });

      /* every choice shows what it would cost with the rest of the current selection */
      this.inputs.forEach(function (i) {
        var alt = self.with(+i.dataset.optInput, i.value), row = i.closest('.ecx-pkg, .ecx-look');
        if (!row) return;
        var price = $('[data-opt-price]', row), sold = $('[data-opt-sold]', row), delta = $('[data-look-delta]', row);
        if (price) price.textContent = alt ? alt.pt : '';
        if (sold) sold.hidden = !!(alt && alt.a);
        if (delta) {
          var std = $('[data-std]', self), base = std ? self.with(+i.dataset.optInput, std.value) : null;
          var d = alt && base ? alt.p - base.p : 0;
          delta.textContent = d > 0 ? '+' + money(d) : delta.dataset.included;
        }
      });

      /* upgrade nudge: price gap to the recommended package, same design */
      if (nudge) {
        var rec = $('[data-rec]', this), txt = '';
        if (rec && !rec.checked && v) {
          var rv = this.with(+rec.dataset.optInput, rec.value);
          if (rv && rv.a && rv.p > v.p) txt = (this.dataset.upsell || '').replace('[diff]', money(rv.p - v.p));
        }
        nudge.textContent = txt;
      }

      this.design();
      if (user && v && this.dataset.updateUrl === 'true' && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
      this.dispatchEvent(new CustomEvent('ecx:variant', { bubbles: true, detail: { variant: v, options: st.options.slice() } }));
    }
    design() {
      var d = $('[data-looks] input:checked', this);
      if (!d) return;
      var prem = !d.hasAttribute('data-std') && !!d.dataset.url;
      $$('[data-look-prop]', this).forEach(function (p) { p.value = d.dataset[p.dataset.lookProp] || ''; });
      this.state.design = { value: d.value, label: d.dataset.label, code: d.dataset.code, url: d.dataset.url };
      /* the big preview and the live buttons follow the chosen design */
      var stage = $('[data-look-stage]', this);
      if (stage) {
        if (prem && d.dataset.img) {
          var img = $('[data-look-stage-img]', stage);
          if (img.getAttribute('src') !== d.dataset.img) img.src = d.dataset.img;
          img.alt = d.dataset.label + ' preview';
          $('[data-look-stage-n]', stage).textContent = d.dataset.label;
          $('[data-look-stage-s]', stage).textContent = d.dataset.style || '';
          stage.href = d.dataset.url;
          stage.hidden = false;
        } else stage.hidden = true;
      }
      $$('[data-live-std]', this).forEach(function (el) { el.hidden = prem; });
      $$('[data-live-look]', this).forEach(function (el) {
        el.hidden = !prem;
        var a = el.tagName === 'A' ? el : $('a', el);
        if (a && prem) a.href = d.dataset.url;
        var n = $('[data-live-look-n]', el); if (n) n.textContent = d.dataset.label;
      });
    }
    rename() {
      var input = $('[data-brand]', this);
      if (!input) return;
      var url = $('[data-url]', this), tab = $('[data-tab-title]', this), stub = $('[data-stub-to]', this), btn = $('[data-rename]', this);
      var orig = input.placeholder, tabOrig = tab ? tab.textContent : '', stubOrig = stub ? stub.textContent : '', niche = this.dataset.niche || '';
      var m = document.createElement('span'); m.className = 'ecx-measure'; m.setAttribute('aria-hidden', 'true');
      url.appendChild(m);
      var fitW = function (t) { m.style.font = getComputedStyle(input).font; m.textContent = t || orig; input.style.width = Math.ceil(m.getBoundingClientRect().width + 2) + 'px'; };
      fitW('');
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitW(input.value); });
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); input.focus(); });
      input.addEventListener('input', function () {
        var v = input.value.replace(/\.com$/i, '');
        if (!v.trim()) { url.classList.remove('is-typing'); fitW(''); if (tab) tab.textContent = tabOrig; if (stub) stub.textContent = stubOrig; return; }
        url.classList.add('is-typing'); fitW(v);
        if (tab) tab.textContent = v.trim() + (niche ? ' | ' + niche : '');
        if (stub) stub.textContent = v.trim();
      });
      input.addEventListener('blur', function () {
        var slug = input.value.toLowerCase().replace(/\.com$/, '').replace(/[^a-z0-9]+/g, '');
        if (slug) { input.value = slug; fitW(slug); }
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    }
    addToCart() {
      var self = this;
      if (!this.form) return;
      var submit = function (e) {
        if (e) { e.preventDefault(); e.ecxAjaxHandled = true; }
        var btn = $('[data-add]', self.form);
        if (btn && btn.disabled) return;
        $$('[data-add]', self).forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
        var err = $('[data-add-error]', self);
        if (err) err.hidden = true;
        /* the cart line carries the exact variant plus any properties[...] fields in the form */
        var item = { id: +self.idInput.value, quantity: 1 }, props = {};
        new FormData(self.form).forEach(function (val, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && val !== '') props[m[1]] = val; });
        if (Object.keys(props).length) item.properties = props;
        if (!item.id) { $('[data-add]', self).forEach(function (b) { b.removeAttribute('aria-busy'); }); return; }
        var items = [item], emailBox = $('[data-email-addon]', self);
        if (emailBox && emailBox.checked) {
          var emailVariant = +emailBox.dataset.emailVariant;
          if (!emailVariant) {
            if (err) { err.textContent = 'The email add-on is temporarily unavailable. Please deselect it and try again.'; err.hidden = false; }
            $('[data-add]', self).forEach(function (b) { b.removeAttribute('aria-busy'); });
            return;
          }
          items.push({
            id: emailVariant, quantity: 1,
            properties: { 'For business': emailBox.dataset.emailBusiness || 'Your new business', '_Business product ID': emailBox.dataset.emailProduct || '' }
          });
        }
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('ecx:cart-changed'));
            /* Keep the established EcomChief drawer flow; never route to the unstyled /cart page. */
            var deal = $('ecx-deal');
            if (!deal) {
              var backup = $('[data-ecx-deal-backup]');
              if (backup && backup.content) {
                document.body.appendChild(backup.content.cloneNode(true));
                deal = $('ecx-deal');
              }
            }
            if (deal && typeof deal.open === 'function') deal.open();
            else if (deal) { E.open(deal); if (typeof deal.refresh === 'function') deal.refresh(); }
            else if (err) { err.textContent = 'Your items were added, but the deal drawer could not open. Please try the Your deal button.'; err.hidden = false; }
          })
          .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || err.dataset.fallback; err.hidden = false; } })
          .then(function () { $$('[data-add]', self).forEach(function (b) { b.removeAttribute('aria-busy'); }); });
      };
      this.form.addEventListener('submit', submit);
      var mb = $('[data-mbar-add]', this);
      if (mb) mb.addEventListener('click', submit);
    }
    mobileBar() {
      var bar = $('[data-mbar]', this), anchor = $('[data-add]', this.form || this);
      if (!bar || !anchor || !('IntersectionObserver' in window)) { if (bar) bar.classList.add('is-on'); return; }
      this.io = new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 });
      this.io.observe(anchor);
    }
  }
  if (!customElements.get('ecx-product')) customElements.define('ecx-product', EcxProduct);

  /* ======================================================================
     PREVIEW VIEWER: desktop / tablet / phone, live demo on request
     ====================================================================== */
  var DEV = {
    desktop: { w: 1366, h: 854, bez: 0, bar: 34, r: 14 },
    tablet: { w: 820, h: 1180, bez: 14, bar: 0, r: 34 },
    phone: { w: 390, h: 844, bez: 11, bar: 0, r: 48 }
  };
  class EcxViewer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.live = this.dataset.live || '';
      this.frame = $('.ecx-frame', this);
      this.dev = $('[data-device]', this);
      this.shell = $('[data-shell]', this);
      this.screen = $('[data-screen]', this);
      this.cap = $('[data-vcap]', this);
      this.size = $('[data-vcap-size]', this);
      this.btns = $$('[data-view]', this);
      this.mode = 'desktop';
      this.btns.forEach(function (b) { b.addEventListener('click', function () { self.view(b.dataset.view); }); });
      $$('[data-live-go]', this).forEach(function (b) { b.addEventListener('click', function () { self.view('desktop', true); }); });
      $$('[data-live-off]', this).forEach(function (b) { b.addEventListener('click', function () { self.shots(); }); });
      var track = $('[data-open]', this);
      if (track) track.addEventListener('click', function (e) {
        if (e.target.closest('button, a')) return;
        if (track.dataset.open === 'live') self.view('desktop', true);
        else { var fs = $('[data-fullscreen]', self); if (fs) fs.click(); }
      });
      if ('ResizeObserver' in window && this.dev) { this.ro = new ResizeObserver(function () { self.fit(); }); this.ro.observe(this); }
      this.onResize = function () { self.fit(); };
      window.addEventListener('resize', this.onResize, { passive: true });
    }
    disconnectedCallback() { if (this.ro) this.ro.disconnect(); window.removeEventListener('resize', this.onResize); }
    press(m) { this.btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === m ? 'true' : 'false'); }); }
    shots() {
      this.mode = 'desktop';
      this.dataset.state = 'shots';
      this.press('desktop');
      if (this.dev) this.dev.hidden = true;
      if (this.cap) this.cap.hidden = true;
      this.frame.hidden = false;
    }
    view(m, goLive) {
      if (!this.dev) return;
      /* desktop without the live demo = the screenshot gallery */
      if (m === 'desktop' && !(this.live && (goLive || this.dataset.state === 'live'))) return this.shots();
      /* a desktop demo shrunk onto a phone screen is unreadable: start small screens on the phone view */
      if (goLive && m === 'desktop' && window.innerWidth < 700 && $('[data-view="phone"]', this)) m = 'phone';
      this.mode = m;
      this.press(m);
      this.frame.hidden = true;
      this.dev.hidden = false;
      this.dev.dataset.dev = m;
      if (this.live) {
        this.dataset.state = 'live';
        if (!this.ifr) {
          var f = document.createElement('iframe');
          f.src = this.live;
          f.title = this.dataset.liveTitle || 'Live demo';
          if (this.dataset.ecxPrivatePreview === 'true') {
            f.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms');
            f.setAttribute('referrerpolicy', 'no-referrer');
          } else {
            f.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox');
            f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
          }
          f.setAttribute('allow', 'fullscreen');
          var sc = this.screen;
          f.addEventListener('load', function () { sc.classList.add('is-loaded'); });
          this.screen.appendChild(f);
          this.ifr = f;
        }
        if (this.cap) this.cap.hidden = false;
      } else {
        this.dataset.state = 'device';
        $$('[data-shot]', this.screen).forEach(function (el) { el.hidden = el.dataset.shot !== m; el.scrollTop = 0; });
      }
      this.fit();
    }
    fit() {
      if (!this.dev || this.dev.hidden) return;
      var d = DEV[this.mode], cs = getComputedStyle(this.dev);
      var bw = this.dev.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var maxH = this.mode === 'desktop' ? Infinity : Math.min(Math.max(window.innerHeight * 0.72, 460), 780);
      var s = Math.min((bw - 2 * d.bez) / d.w, (maxH - 2 * d.bez - d.bar) / d.h, 1);
      s = Math.max(s, 0.1);
      var sc = this.screen.style, sh = this.shell.style;
      sc.width = d.w + 'px'; sc.height = d.h + 'px';
      sc.left = d.bez + 'px'; sc.top = (d.bez + d.bar) + 'px';
      sc.transform = 'scale(' + s + ')';
      sc.borderRadius = this.mode === 'desktop' ? '0' : Math.max(0, d.r - d.bez) / s + 'px';
      sh.width = Math.round(d.w * s + 2 * d.bez) + 'px';
      sh.height = Math.round(d.h * s + 2 * d.bez + d.bar) + 'px';
      sh.borderRadius = d.r + 'px';
      if (this.size) this.size.textContent = d.w + ' × ' + d.h + ' at ' + Math.round(s * 100) + '%';
    }
  }
  if (!customElements.get('ecx-viewer')) customElements.define('ecx-viewer', EcxViewer);

  /* optional sale countdown: to the next 12:00 (midday or midnight) */
  $$('[data-timer]').forEach(function (t) {
    var out = $('[data-timer-out]', t);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tick = function () {
      var now = new Date(), end = new Date(now);
      end.setHours(now.getHours() < 12 ? 12 : 24, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      out.textContent = pad(Math.floor(d / 3600)) + ':' + pad(Math.floor(d % 3600 / 60)) + ':' + pad(d % 60);
    };
    tick(); setInterval(tick, 1000);
  });

  /* calculators and buy links embedded in listing descriptions */
  var vs = document.getElementById('echd-vs'), rs = document.getElementById('echd-rs');
  if (vs && rs) {
    var fmt = function (n) { return n.toLocaleString('en-US'); };
    var set = function (id, v) { var el = document.getElementById(id); if (el) el.textContent = v; };
    var calc = function () {
      var v = parseInt(vs.value, 10), r = parseFloat(rs.value), m = v * 0.03 * 120 * (r / 100), y = m * 12;
      set('echd-vv', fmt(v) + ' visitors / mo'); set('echd-rv', r + '% commission');
      set('echd-mo', '$' + fmt(Math.round(m))); set('echd-yr', '$' + fmt(Math.round(y))); set('echd-roi', Math.round(y / 99) + '×');
      var vf = document.getElementById('echd-vf'), rf = document.getElementById('echd-rf');
      if (vf) vf.style.width = (((v - 500) / 49500) * 100).toFixed(2) + '%';
      if (rf) rf.style.width = (((r - 3) / 5) * 100).toFixed(2) + '%';
    };
    vs.addEventListener('input', calc); rs.addEventListener('input', calc); calc();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.echd-buy-trigger');
    if (!b) return;
    e.preventDefault();
    var t = $('form[data-ecx-form]') || $('[data-add]');
    if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 100, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* software revenue scenario calculator */
  $$('[data-ecx-calc]').forEach(function (root) {
    var c = $('[data-calc-customers]', root), p = $('[data-calc-price]', root), mrr = $('[data-calc-mrr]', root), arr = $('[data-calc-arr]', root);
    if (!c || !p || !mrr || !arr) return;
    var usd = function (v) { return '$' + Math.max(0, v).toLocaleString('en-US', { maximumFractionDigits: 0 }); };
    var upd = function () { var m = Math.max(0, +c.value || 0) * Math.max(0, +p.value || 0); mrr.textContent = usd(m); arr.textContent = usd(m * 12); };
    c.addEventListener('input', upd); p.addEventListener('input', upd); upd();
  });
})();
